import {v4 as guid} from 'uuid';
import * as requestFromServer from './agentsIncomesCrud';
import {
  agentsIncomesSlice,
  callTypes
} from './agentsIncomesSlice';
import {RequestCancellationManager} from '../../_common/utils/RequestCancellationManager';

export const getAgentsIncomesListIDPrefix = 'getAgentsIncomesList';
const {actions} = agentsIncomesSlice;

const getAgentsIncomesList = storeMethod => queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.list}));

  const requestID = `${getAgentsIncomesListIDPrefix}-${guid()}`;
  const cancellationHandlers = RequestCancellationManager.createCancellationHandlers(requestID);

  return requestFromServer
    .findAgentsIncomes(queryParams, cancellationHandlers)
    .then(response => {
      const {errorCode, data: {list, totalAgentsCount, pageCount}} = response.data;
      if (errorCode !== 0) throw new Error();

      dispatch(storeMethod({
        totalAgentsCount,
        pageCount,
        entities: list
      }));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t find customers';
      dispatch(actions.catchError({error, callType: callTypes.list}));
    })
    .finally(() => {
      RequestCancellationManager.forgetRequest(requestID);
    });
};

export const exportAgentsIncomesFile = queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .getAgentsIncomesFile(queryParams)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      return data?.list;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t get file!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const getAgentsIncomes = getAgentsIncomesList(actions.agentsIncomesFetched);
export const getNextAgentsIncomes = getAgentsIncomesList(actions.agentsIncomesAppended);
